export const securePaymentRules = {
    cardholder: {
        required: true,
        min: 2,
        max: 255,
        "only-letters": true,
    },
    cardNumber: {
        required: true,
        min: 16, // counting 3 - (13)
        max: 20, // counting 3 - (17)
    },
    expiryDate: {
        required: true,
        "valid-expiration-date": true,
    },
    cvv: {
        required: true,
        min: 3,
        max: 4,
        is_numeric: true,
    },
    automaticPaymentDate: {
        required: true,
    },
};
